<template>
	<div>
		<h3 class="ch-block-title text-left text-uppercase mb-0">
			CUSTOMER REVIEWS
		</h3>
		<div
			class="review-column d-flex flex-column"
			v-for="(r, i) in reviews"
			:key="i"
		>
			<div class="row mx-0">
				<div class="col-12 px-0">
					<img class="float-left" :src="r.userImage" :alt="r.name" />
					<div class="d-flex flex-wrap flex-row">
						<span class="">
							<span class="rw-name">{{ r.name }}</span>
							<br />
							<span>
								<span
									v-for="(star, i2) in getStars(r.stars)"
									:key="i2"
								>
									<i
										class="fas fa-star"
										v-if="star === 1"
									></i>
									<i
										class="fas fa-star-half"
										v-if="star === 0.5"
									></i>
								</span>
							</span>
						</span>

						<span class="rw-date">{{ formatDate(r.date) }}</span>
					</div>
				</div>
			</div>
			<p class="rw-comment mb-0">
				{{ r.comment }}
			</p>
		</div>
		<!-- <div class="d-flex flex-wrap">
			<div
				class="review-column d-flex flex-column flex-lg-wrap"
				v-for="(r, i) in reviews"
				:key="i"
			>
				<div class="d-flex flex-wrap">
					<span> <img :src="r.userImage" :alt="r.name" /></span>
					<div class="d-flex flex-wrap">
						<span class="rw-name flex-grow-1">{{ r.name }}</span>
						<span class="br-col"></span>
						<span class="">
							<span
								v-for="(star, i2) in getStars(r.stars)"
								:key="i2"
							>
								<i class="fas fa-star" v-if="star === 1"></i>
								<i
									class="fas fa-star-half"
									v-if="star === 0.5"
								></i>
							</span>
						</span>
					</div>
					<span class="rw-date">{{ formatDate(r.date) }}</span>
				</div>
				<div>
					<p class="rw-comment flex-basis-100 mb-0">
						{{ r.comment }}
					</p>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
export default {
	props: {
		reviews: {
			type: Array,
			default: () => [],
		},
		locale: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {}
	},
	methods: {
		formatDate(date) {
			let options = { year: "numeric", month: "long", day: "numeric" }
			let dt = new Date(date).toLocaleDateString(
				this.locale.language,
				options
			)

			return dt
		},
		getStars(stars) {
			let num = []
			let int = Math.floor(stars)
			let dec = stars % 1

			for (let i = 0; i < int; i++) {
				num.push(1)
			}

			if (dec !== 0) {
				num.push(0.5)
			}

			return num
		},
	},
}
</script>

<style lang="scss" scoped></style>
